window.__ark_ads__ = window.__ark_ads__ || {},

  function(t) {
    var a = new Date
      , n = String(a.getFullYear())
      , r = String(a.getMonth() + 1).padStart(2, "0")
      , c = String(a.getDate()).padStart(2, "0")
      , e = "".concat(n).concat(r).concat(c)
      , o = "https://www.gannett-cdn.com/ads/gntx/games.js?v=".concat(e)
      , d = t.currentScript || t.querySelector('script[src*="games.usatoday.com/display-ads.js"]');
    if (!d)
      throw Error("Can't identify current script");
    var s = d.onload;
    d.onload = null;
    var i = Object.assign(t.createElement("script"), {
      src: o,
      onload: s,
      async: "async",
      defer: !0
    });
    (t.head || t.body).appendChild(i);
    (t.head || t.body).appendChild(Object.assign(t.createElement("script"), {
      async: "async",
      src: 'https://dn0qt3r0xannq.cloudfront.net/arkadium-QKoDH9ov9c/arkadium-video/prebid-load.js',
    }));
  }(document);

